<template>
    <v-app v-cloak id="inspire">
        <router-view />
        <toast-box ref="toast-box" :message="message" @close="dealMessage" />
        <error-dialog
            v-if="error || embedded.error"
            ref="error-dialog"
            :message="error ? errorMessage : embeddedErrorMessage"
            @clickClose="closeError"
        />
        <progress-dialog :is-show="process.running" :message="processMessage" :hide-overlay="true" />
    </v-app>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { ErrorDialog, ToastBox, ProgressDialog } from './components/molecules';
import { useRootStore } from './store/composables';
import { useTranslation } from './composables/translation';
import { useNsioHistoryStore } from './store/history/';

/*
 * composables
 */
const { message, error, errorCode, errorMsg, embedded, process, dealError, dealMessage } = useRootStore();
const history = useNsioHistoryStore();
const { t } = useTranslation();

/*
 * getter
 */
const errorMessage = computed(() => `${errorCode.value} - ${errorMsg.value}`);
const embeddedErrorMessage = computed(() => `${embedded.value.errorCode} - ${embedded.value.errorMsg}`);
const processMessage = computed(() => {
    const msgKey = process.value.msgKey;
    return msgKey ? t(msgKey) : '';
});

/*
 * methods
 */
function closeError(): void {
    dealError();
}

/*
 * lifecycle hooks
 */
history.reset();
</script>

<style lang="scss">
[v-cloak] {
    display: none;
}
h1,
h2,
h3,
h4,
h5,
h6 {
    color: #616161;
}
td {
    word-break: break-all;
}
.shape.cutie {
    border-radius: 15px;
    border: none;
}
.icon-padding-unified {
    padding-left: 6px;
    padding-right: 6px;
}
.required-before:before,
.required:after,
.comments:before {
    content: '*';
    color: red;
}
.disabled-font {
    color: darkgrey;
}
.label-for-input-form {
    min-height: 68px;
    padding: 4px;
    word-wrap: break-word;
}
</style>
